import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "explore-outer hide-scrollbar-mobile" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "link-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_Searchbar = _resolveComponent("Searchbar")!
  const _component_ClusterHList = _resolveComponent("ClusterHList")!
  const _component_NcButton = _resolveComponent("NcButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
          key: 0,
          class: "fill-block"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t('memories', 'Explore')), 1),
          (_ctx.isNative)
            ? (_openBlock(), _createBlock(_component_Searchbar, {
                key: 0,
                class: "searchbar"
              }))
            : _createCommentVNode("", true),
          (_ctx.recognize.length)
            ? (_openBlock(), _createBlock(_component_ClusterHList, {
                key: 1,
                title: _ctx.t('memories', 'Recognize'),
                link: "/recognize",
                clusters: _ctx.recognize
              }, null, 8, ["title", "clusters"]))
            : _createCommentVNode("", true),
          (_ctx.facerecognition.length)
            ? (_openBlock(), _createBlock(_component_ClusterHList, {
                key: 2,
                title: _ctx.t('memories', 'Face Recognition'),
                link: "/facerecognition",
                clusters: _ctx.facerecognition
              }, null, 8, ["title", "clusters"]))
            : _createCommentVNode("", true),
          (_ctx.places.length)
            ? (_openBlock(), _createBlock(_component_ClusterHList, {
                key: 3,
                title: _ctx.t('memories', 'Places'),
                link: "/places",
                clusters: _ctx.places
              }, null, 8, ["title", "clusters"]))
            : _createCommentVNode("", true),
          (_ctx.tags.length)
            ? (_openBlock(), _createBlock(_component_ClusterHList, {
                key: 4,
                title: _ctx.t('memories', 'Tags'),
                link: "/tags",
                clusters: _ctx.tags
              }, null, 8, ["title", "clusters"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
              return (_openBlock(), _createBlock(_component_NcButton, {
                class: "link",
                ariaLabel: category.name,
                key: category.name,
                to: category.link,
                onClick: ($event: any) => (category.click?.()),
                variant: "tertiary-no-background"
              }, {
                icon: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(category.icon)))
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(category.name), 1)
                ]),
                _: 2
              }, 1032, ["ariaLabel", "to", "onClick"]))
            }), 128))
          ])
        ]))
  ]))
}